(
    function (skyward, $, undefined)
    {
        skyward.raceverifiedbydatecontrols = skyward.raceverifiedbydatecontrols || {};

        var init = function (selector)
        {
            var demographicsNameSelector = $(selector).find("#editEthnicity.currentRecordContent.dataObjectViewer");
            var studentProfileSelector = $(selector).find("#StudentProfile.currentRecordContent.dataObjectViewer");
            var employeeProfileSelector = $(selector).find("#EmployeeProfile.currentRecordContent.dataObjectViewer");
            var addStudentOrEmployeeWorkflowSelector = $(selector).filter(".workflowContent");
            var pageComboBox;

            if (demographicsNameSelector.length > 0)
            {
                pageComboBox = demographicsNameSelector.find(".raceVerifiedByCodeComboBox");
            }
            else if (studentProfileSelector.length > 0)
            {
                pageComboBox = studentProfileSelector.find(".raceVerifiedByCodeComboBox");
            }
            else if (employeeProfileSelector.length > 0)
            {
                pageComboBox = employeeProfileSelector.find(".raceVerifiedByCodeComboBox");
            }
            else if (addStudentOrEmployeeWorkflowSelector.length > 0)
            {
                pageComboBox = addStudentOrEmployeeWorkflowSelector.find(".raceVerifiedByCodeComboBox");
            }
            else
            {
                return;
            }

            var raceVerifiedByOnChange = function ()
            {
                skyward.raceverifiedbydatecontrols.setComboBoxStatus();
            };

            pageComboBox.on('change', raceVerifiedByOnChange);

            skyward.raceverifiedbydatecontrols.setComboBoxStatus(true);
        };

        skyward.raceverifiedbydatecontrols.setComboBoxStatus = function (isInitialPageLoad)
        {
            var demographicsNameSelector = $("#editEthnicity.currentRecordContent.dataObjectViewer");
            var studentProfileSelector = $("#StudentProfile.currentRecordContent.dataObjectViewer");
            var employeeProfileSelector = $("#EmployeeProfile.currentRecordContent.dataObjectViewer");
            var addStudentOrEmployeeWorkflowSelector = $(".workflowContent ");
            var pageComboBox;
            var pageDateTextBox;

            if (demographicsNameSelector.length > 0)
            {
                pageComboBox = demographicsNameSelector.find(".raceVerifiedByCodeComboBox");
                pageDateTextBox = demographicsNameSelector.find(".datepicker.raceVerifiedDatePicker");
            }
            else if (addStudentOrEmployeeWorkflowSelector.length > 0)
            {
                pageComboBox = addStudentOrEmployeeWorkflowSelector.find(".raceVerifiedByCodeComboBox");
                pageDateTextBox = addStudentOrEmployeeWorkflowSelector.find(".datepicker.raceVerifiedDatePicker");
            }
            else if (studentProfileSelector.length > 0)
            {
                pageComboBox = studentProfileSelector.find(".raceVerifiedByCodeComboBox");
                pageDateTextBox = studentProfileSelector.find(".datepicker.raceVerifiedDatePicker");
            }
            else if (employeeProfileSelector.length > 0)
            {
                pageComboBox = employeeProfileSelector.find(".raceVerifiedByCodeComboBox");
                pageDateTextBox = employeeProfileSelector.find(".datepicker.raceVerifiedDatePicker");
            }
            else
            {
                return;
            }

            var pageDatePickerTrigger = pageDateTextBox.siblings(".datepicker-trigger");

            if (pageComboBox.length == 0 || pageDateTextBox.length == 0 || pageDatePickerTrigger.length == 0)
            {
                return;
            }

            if (skyward.controls.getValue(pageComboBox) == 'N')
            {
                skyward.controls.disable(pageDateTextBox);
                pageDatePickerTrigger.css("display", "none");
                pageDateTextBox.val("");
            }
            else
            {
                if (!isInitialPageLoad || !pageDateTextBox.is(":disabled"))
                {
                    skyward.controls.enable(pageDateTextBox);
                }
                pageDatePickerTrigger.css("display", "inline");

                if (skyward.controls.getValue(pageDateTextBox) == 'Invalid Date')
                {
                    pageDateTextBox.val(skyward.raceverifiedbydatecontrols.getCurrentDate());
                }
            }
        };

        skyward.raceverifiedbydatecontrols.getCurrentDate = function ()
        {
            var currentDate = skyward.time.now();
            var weekday = currentDate.getDay();
            var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            var strDate = ("0" + (currentDate.getMonth() + 1)).slice(-2) + "/" + ("0" + currentDate.getDate()).slice(-2) + "/" + currentDate.getFullYear() + " " + days[weekday];
            return strDate;
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);